import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/dashboard/members")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/org/members" });
	},
});
